import {deepClone} from '@wix/wix-immutable-proxy'
import type {DocumentFSUpdate} from '@wix/document-services-types'

export class DocumentUpdateState {
    private EMPTY_STATE: DocumentFSUpdate = {pages: {}, fragments: {}}
    private state: DocumentFSUpdate

    constructor() {
        this.state = this.EMPTY_STATE
    }

    getState(): DocumentFSUpdate {
        return deepClone(this.state)
    }

    append(documentUpdate: DocumentFSUpdate): DocumentFSUpdate {
        this.state = {
            ...this.state,
            ...documentUpdate,
            pages: {
                ...this.state.pages,
                ...documentUpdate.pages
            },
            fragments: {
                ...this.state.fragments,
                ...documentUpdate.fragments
            }
        }
        return this.getState()
    }

    clear() {
        this.state = this.EMPTY_STATE
    }
}
